import { styled } from "@mui/material/styles";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import { Grid, IconButton, Text } from "designSystem/index";
import { hoverStyle } from "designSystem/styles/style-functions";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";

const PREFIX = "Disabled";

const classes = {
	hover: `${PREFIX}hover`,
};

const StyledCssColumnGrid = styled(CssColumnGrid)(({
	theme,
}) => ({
	[`& .${classes.hover}`]: {
		...hoverStyle(theme),

		"& .MuiGrid-item": {
			alignItems: "center",
			display: "flex",
		},
	},
}));

export default () => {
	return (
		<StyledCssColumnGrid columns={5}>
			<Text semiBold text="default" />
			<Text semiBold text="defaultOnGrey" />
			<Text semiBold text="primary" />
			<Text semiBold text="secondary" />
			<Text semiBold text="outline" />
			<IconButton
				design="default"
				disabled
				size="large"
			>
				<AllInclusiveIcon />
			</IconButton>
			<Grid
				className={classes.hover}
				container
				spacing={1}
				wrap="nowrap"
			>
				<Grid item>
					<Text noWrap text="Item with hover" />
				</Grid>
				<Grid item>
					<IconButton
						design="defaultOnGrey"
						disabled
						size="large"
					>
						<AllInclusiveIcon />
					</IconButton>
				</Grid>
			</Grid>
			<IconButton
				design="primary"
				disabled
				size="large"
			>
				<AllInclusiveIcon />
			</IconButton>
			<IconButton
				design="secondary"
				disabled
				size="large"
			>
				<AllInclusiveIcon />
			</IconButton>
			<IconButton
				design="outline"
				disabled
				size="large"
			>
				<AllInclusiveIcon />
			</IconButton>
		</StyledCssColumnGrid>
	);
};